import styled, { css } from 'styled-components';

const HOVER_STYLES = css`
  &:hover {
    background: var(
      --ds-background-accent-blue-subtlest-hovered,
      var(--ds-fb-background-accent-blue-subtlest-hovered)
    );
  }
`;
const ACTIVE_STYLES = css`
  &:active {
    background: var(
      --ds-background-accent-blue-subtlest-pressed,
      var(--ds-fb-background-accent-blue-subtlest-pressed)
    );
  }
`;

export const ContainerStyled = styled.div<{
  isHighlighted?: boolean;
  isDraggingOver?: boolean;
  isDisabled?: boolean;
}>`
  box-sizing: border-box;
  border: 2px solid transparent;
  padding: 10px 6px 10px 22px;
  line-height: 24px;
  border-radius: 8px;

  display: flex;
  align-items: center;
  gap: 4px;

  cursor: pointer;

  ${({ isHighlighted = false, isDraggingOver = false, isDisabled = false }) => {
    if (isDisabled) {
      return css`
        cursor: not-allowed;
        color: var(--ds-text-disabled, var(--ds-fb-text-disabled));
      `;
    }

    if (isDraggingOver) {
      return css`
        border: 2px solid
          var(--ds-border-accent-blue, var(--ds-fb-border-accent-blue));
      `;
    }

    if (isHighlighted) {
      return css`
        ${HOVER_STYLES};
        ${HOVER_STYLES};
        background: var(
          --ds-background-accent-blue-subtlest,
          var(--ds-fb-background-accent-blue-subtlest)
        );
      `;
    }

    return css`
      ${HOVER_STYLES};
      ${ACTIVE_STYLES}
    `;
  }};
`;
